  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">

    <v-row no-gutters>
      <v-col >
          <h4 style="text-align:center;"> <span>Inscrição na Cadeira em atraso</span></h4>

<div class="text-center">

 <v-container fluid>
    <v-row align="center">

      <v-col class="d-flex" cols="3" sm="3">
          <v-text-field
            v-model="pesquisa"
            label="Informe o nome  ,  número de matricula( ou Bilhete )"
          ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="4" sm="2" >

          <v-btn :disabled="pesquisa === ''" color="primary" @click="Pesquisar()"><v-icon>search</v-icon></v-btn>

      </v-col>
     <v-col class="d-flex" cols="4" sm="4" >

           <div style="margin-left:10px;" v-if="this.$store.state.hasMessage" :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
          <label style="color:red" v-if="!msg_pesquisa">Estudante não encontrado!</label>

      </v-col>
     <!-- <v-col cols="12" sm="3">
          <v-menu :close-on-content-click="false"
      offset-x
      offset-y  >
      <template v-slot:activator="{ on }">
        <v-btn
          color="green darken-1"
          dark
          v-on="on"
          :disabled= !estudante_dados.length
        >
        <v-icon>settings</v-icon>
          Operações Estudante
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="mudanca_classe()">Solicitar Mudança de classe</v-list-item>
        <v-list-item @click="ShowDialog()" :disabled="true">Habilitar à usuário</v-list-item>
       </v-list>
    </v-menu>
      </v-col>-->

    </v-row>
    <v-row>
        <v-col class="d-flex" cols="4" sm="5">
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>

    </v-row>

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar color="grey"></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Pesquisa Local - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Dados Pessoais</strong>
    </v-card-text>
    <hr>
    <v-row>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Nome:{{(this.estudante_dados.length)?(this.estudante_dados[0].nome):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(this.estudante_dados.length)?(this.estudante_dados[0].matricula):''}}</v-chip>
     </v-col>
    </v-row>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <strong> {{titulo}}</strong>
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="this.estudante_dados"
          >
     <template v-slot:item.action="{ item }">
              <v-icon  color="primary" class="mr-2" v-if="item.idAno_Academico === 4" @click="editItem(item)">print</v-icon>
            </template>
      </v-data-table>

  </v-col>

</v-row>
  </v-card>
  </v-container>

  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    e6: 1,
    select1: null,
    pesquisa_parameto: null,
    dialog_show: false,
    dialog_cursoResultado: false,
    estudante_dados: [],
    idMatricula: null,
    msg_pesquisa: true,
    motivo: '',
    cursoSelecionado: null,
    dialogo_turma: false,
    idanolectivo: 0,
    dialogo_curso: false,
    dialogo_classe: false,
    classe_selecionada: '',
    classe_id: 0,
    turma_selecionada: '',
    pesquisa: '',
    turmaSelecionada: null,
    cursos: [],
    cursos_filtered: [],
    estudante: true,
    progresso: false,
    selectedItem: null,
    dialog_confirmar2: false,
    progresso_2: false,
    progresso_3: false,
    Pessoas: [],
    curso_selecionado_mc: '',
    turmasAll: [],
    turmas_filtered: [],
    turmas_filtered_mt: [],
    classesEstudante: [],
    dialog_curso: false,
    dialog_curso2: false,
    turmas_filtered_mc: [],
    retornoMudanca: null,
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    Classes_filtradas: [],
    datebi: null,
    date: null,
    descricao: 'Nº do Bi',
    dialog_confirmar: false,
    dialog_delete: false,
    valid: true,
    menu: false,
    turmasAllAno: [],
    menubi: false,
    habilitaBi: false,
    showLink: false,
    overlay: false,
    cursosFiltrados: null,
    startDate: null,
    isLoading: true,
    nomeClasse: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    turmasAllFiltered: [],
    provincias: [],
    searchInDb: '',
    estudantes: [],
    dialog: false,
    // eslint-disable-next-line standard/array-bracket-even-spacing
    classes: ['10ª Classe', '11ª Classe', '12ª Classe', '13ª Classe' ],
    ruleRequired: [value => value || 'campo obrigatorio'],

    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null,
      anoLectivo: '',
      idCurso: ''
    },
    editedItem:
    {
      nome: '',
      pkPessoa: '',
      idMatricula: '',
      bi: '',
      datanascimento: '',
      nomedopai: '',
      nomedamae: '',
      telefone: '',
      descricao_turma: '',
      instituicao: '',
      descricao_curso: '',
      anoLectivo: '',
      resultado: '',
      classe: '',
      idAno_Academico: '',
      idCurso: '',
      pkTurma: '',
      idAnoLectivo: 0,
      idTurma: '',
      idPessoa: '',
      idMAtricula: '',
      idMunicipio: null,
      idPerfil: null,
      morada: '',
      autor: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      dataemissaobi: null,
      ResidenteEm: 1,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      fkTurma: '',
      pkInscricao_na_turma: '',
      idano_academico: 0
    },

    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
      { text: 'Curso - Inscrito ', value: 'descricao_curso' },
      { text: 'Classes( Feitas )', value: 'classe' },
      { text: 'Turma', value: 'descricao_turma' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Aproveitamento', value: 'resultado' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ]

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    lsAnolectivo () {
      return ls.get('anolectivo')
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
  },
  methods: {

    async  Pesquisar () {
      try {
        this.progresso = true
        this.estudante_dados = await axios
          .get('/PesquisaCadeirante/' + this.pesquisa)
          .then(res => res.data)
        this.progresso = false
        if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
      } catch (error) {
        this.progresso = false
      }
    },

    ShowDialog () {
      this.dialog_show = true
    }

  }

}

</script>
